import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ProjectCard from "./ProjectCard.js";
import { projects } from "../../data/portfolio";
import "./Projects.css";

const Projects = () => {
  return (
    <Container fluid className="project-section section-shell">
      <Container>
        <Row className="align-items-end g-4 project-intro">
          <Col lg={8}>
            <div className="section-kicker">Selected work</div>
            <h1 className="section-title">Things I've built for real people.</h1>
          </Col>
          <Col lg={4}>
            <p className="section-copy">
              A mix of production systems, personal builds, and work for a cause — each one shipped, used, and
              maintained rather than left as a demo.
            </p>
          </Col>
        </Row>

        <Row className="project-grid g-4">
          {projects.map((project, index) => (
            <Col lg={4} md={6} key={project.title}>
              <ProjectCard project={project} index={index} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
